import React from "react";
import axios from 'axios'
import Datatables from "../../components/Datatables/Table";
import TableCell from "../../components/Datatables/TableCell";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import ViewExpenseModal from "../../components/Expense/viewModal";
import DeleteConfirmationModal from "../../components/Delete";
const user = JSON.parse(localStorage.getItem("user"));
function ExpenseTable({ loading, dataHeader, data,reload,setReload }) {
  const [modal, setModal] = React.useState(false);
  const [deleteExpenseModal,setDeleteExpenseModal] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);

  const viewExpenseOnClick = (row) => {
    setSelectedRow(row);
    setModal(true);
  };

  const closeModal = () => {
    setDeleteExpenseModal(false);
    setModal(false);
  };

  const handleDeleteExpenseClick = (row) => {
    setSelectedRow(row);
    setDeleteExpenseModal(true);
  }
  const handleDeleteExpenseItem = async(groupId,expenseId) => {
    try{
      const url = `https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/expenses/delete/${expenseId}/groups/${groupId}`
      const response = await axios.delete(url,{
        headers: {
          Authorization: `Bearer ${user.idToken}`,
        },
      })
      console.log('Deleted Successfully',response)
      setDeleteExpenseModal(false);
      setReload(!reload);
      setSelectedRow(null)
      alert('Expense Deleted Successfully')
    }
    catch(e){
      console.log('error',e)
    }
  }

  return (
    <Datatables loading={loading} dataHeader={dataHeader}>
      {data?.map((row, index) => (
        <tr
          key={index}
          className="bg-white border md:border-b block md:table-row rounded-md shadow-md md:rounded-none md:shadow-none mb-5"
        >
          <TableCell dataLabel="Date" showLabel={true}>
            <p className="font-normal text-sm text-gray-500">{row.date}</p>
          </TableCell>
          <TableCell dataLabel="Description" showLabel={true}>
            <p className="font-normal text-sm text-gray-500">
              {row.description}
            </p>
          </TableCell>
          <TableCell dataLabel="lent" showLabel={true}>
            <p className="font-normal text-sm text-gray-500"></p>
            {row.expense < 0 ? (
              <span className="rounded-full py-1 px-3 text-xs font-semibold bg-red-200 text-red-900">
                {row.expense}
              </span>
            ) : (
              <span className="rounded-full py-1 px-3 text-xs font-semibold bg-emerald-200 text-green-900">
                {row.expense}
              </span>
            )}
          </TableCell>
          <TableCell>
            <div className="text-sky-700 inline-flex py-2 px-2 rounded text-sm">
              <button
                className="clickme"
                onClick={() => viewExpenseOnClick(row.data)}
              >
                <FontAwesomeIcon icon={faEye} />
              </button>
            </div>
            <div className="text-sky-700 inline-flex py-2 px-2 rounded text-sm">
              <button
                className="clickme"
                onClick={() => handleDeleteExpenseClick(row.data)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </div>
          </TableCell>
        </tr>
      ))}
       {selectedRow && (
        <ViewExpenseModal
          isOpen={modal}
          setModal={setModal}
          onClose={closeModal}
          expenseData={selectedRow}
        />
      )}
      {deleteExpenseModal && (
        <DeleteConfirmationModal
          handleDeleteItem = {handleDeleteExpenseItem}
          groupId = {selectedRow.groupId}
          expenseId={selectedRow.id}
          onClose={closeModal}
        />
      )}
    </Datatables>
  );
}

export default ExpenseTable;
